import 'intersection-observer';
import React, { useEffect, useRef } from 'react';

interface IObserverContainer {
  children?: React.ReactNode;
  value?: boolean;
  handleState: (props: any) => void;
}
const Observer = (props: IObserverContainer) => {
  const targetRef = useRef<any>(null);

  useEffect(() => {
    const ob = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          props.handleState(entry.isIntersecting);
        });
      },
      {
        root: null,
        threshold: 0,
      },
    );
    ob.observe(targetRef.current);

    return () => {
      ob.disconnect();
    };
  }, []);

  return <div ref={targetRef}>{props.children}</div>;
};

export default Observer;
